import { Size } from '@vtbhome/juicyfront/types';
import { FileDimension } from '../input-file/types';

export const CLOSE_SIZE: Record<FileDimension, Size> = {
    l: 'xs',
    m: 'xxs',
};
